import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { BASEPATH } from './services/config';
import Home from './redirection/Home';
import LegalLayout from './redirection/LegalLayout';
import PrivacyPolicy from './redirection/PrivacyPolicy';
import TermsAndConditions from './redirection/TermsAndConditions';
import './redirection/Home.css';
import './redirection/Legal.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename={BASEPATH}>
      <Routes>
        <Route element={<LegalLayout />}>
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        </Route>
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();

// Block PWA install prompt
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
});

// Also block appinstalled event
window.addEventListener('appinstalled', () => {
  // Do nothing
});
